// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b77e9fcf","160":"f69464d3","208":"7ed72dde","293":"20631c50","453":"41811d64","516":"59fc9aed","519":"599cdb52","917":"f9d4add8","946":"acc8c049"}[chunkId] + ".chunk.js";
};